import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const RectangleVerticalTwoLinesIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M5 4C5 2.89543 5.89543 2 7 2H17C18.1046 2 19 2.89543 19 4V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V4ZM17 4L7 4V20H17V4Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M8.23077 14C8.23077 13.4477 8.67849 13 9.23077 13H14.7692C15.3215 13 15.7692 13.4477 15.7692 14 15.7692 14.5523 15.3215 15 14.7692 15H9.23077C8.67849 15 8.23077 14.5523 8.23077 14zM8.23077 17C8.23077 16.4477 8.67849 16 9.23077 16H11.5385C12.0908 16 12.5385 16.4477 12.5385 17 12.5385 17.5523 12.0908 18 11.5385 18H9.23077C8.67849 18 8.23077 17.5523 8.23077 17z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
